import { Card } from "@/components/ui/card";
import { FileText } from "lucide-react";
import type { PropertyDocumentation as PropertyDocumentationType } from "@/integrations/supabase/types/tables/realEstate";

interface PropertyDocumentationProps {
  documentation: PropertyDocumentationType | null;
}

export const PropertyDocumentation = ({ documentation }: PropertyDocumentationProps) => {
  if (!documentation) return null;

  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-4">Documentation</h2>
      <div className="space-y-4">
        {documentation.title_deed && (
          <div className="flex items-center space-x-3">
            <FileText className="h-5 w-5 text-primary" />
            <span>Title Deed</span>
          </div>
        )}
        {documentation.permits?.length > 0 && (
          <div>
            <h3 className="font-medium mb-2">Permits</h3>
            <ul className="space-y-2">
              {documentation.permits.map((permit, index) => (
                <li key={index} className="flex items-center space-x-3">
                  <FileText className="h-5 w-5 text-primary" />
                  <span className="text-muted-foreground">{permit}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
        {documentation.certificates?.length > 0 && (
          <div>
            <h3 className="font-medium mb-2">Certificates</h3>
            <ul className="space-y-2">
              {documentation.certificates.map((cert, index) => (
                <li key={index} className="flex items-center space-x-3">
                  <FileText className="h-5 w-5 text-primary" />
                  <span className="text-muted-foreground">{cert}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </Card>
  );
};